module.exports = __webpack_public_path__ + "img/h5_block02.2a5f448e.webp";